export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Settings.json?hash=4b6458f60057c1f23327298ea7127214";